//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service'
import HomeService from '@/service/homepage'
import SurplusBuildingService from '@/service/surplus_buildings'
import BusinessBuildingService from '@/service/business_building'
import LocalData from '@/utils/local_data'
import PageService from '@/service/consultant'
import HouseItem from '@/components/business/house_item'
import SurplusHouseItem from '@/components/business/surplus_house_item'


import SearchSelect from './_search_select'

import { UserLog, sendCtmEvtLog } from '@/utils/log'
import HotSearch from '@/data/hot_search'
import Pagination from '@/common/mixins/pagination'

import { handleSurplusItem } from '@/common/utils/map_view_data'

import SearchItem from './_search_item'
import { debounce } from '@/utils'
import SearchLoading from './_search_loading'

import { BUILDING_STATUS } from '@/constant'

const SUBMIT_TYPE = {
    NONE: 1,
    DOING: 2,
    DONE: 3
}
let TIMER = 0
export default {
    mixins: [
        Pagination
    ],
    watch: {
        name () {
            if (this.submit_state !== SUBMIT_TYPE.DOING) {
                this.submit_state = SUBMIT_TYPE.NONE
                this.checkNameChange()
            }
        },
        items (latest) {
            if (latest && !latest.length && this.name) {
                this.getRecommend()
            }
        },
        focus (val) {
            console.log('focus', val)
            if (val) {
                this.$refs.search_input.focus()
            } else {
                this.$refs.search_input.blur()
            }
        }
    },
    data () {
        return {
            show_search_loading: false,
            search_items:[],
            submit_state: SUBMIT_TYPE.NONE,
            per: 10,
            type: '',
            feature: '',
            name: '',
            history: [],
            hot_search_list: '',
            hot_search_keyword: '',
            hot_search_keyword_id: '',
            start: false,
            banners: [],
            recommend_list: [],
            brand: {},
            fold_history_list: false,
            focus: true
        }
    },
    computed: {
        placeholder () {
            return this.hot_search_keyword ?  `搜索：${this.hot_search_keyword}` : '按楼盘名字搜索'
        },
        showHistory () {
            return this.search_items.length === 0 && this.items.length === 0 && this.recommend_list.length === 0
        },
        showSearchHistory () {
            return this.showHistory && this.history && this.history.length > 0
        },
        show_dynamic_search () {
            return this.submit_state !== SUBMIT_TYPE.DONE && this.search_items.length > 0
        },
        show_submited_bottom() {
            return this.submit_state === SUBMIT_TYPE.DONE
        },
        show_recommend_list () {
            return !this.show_dynamic_search
                && this.items && !this.items.length > 0
                && this.recommend_list && this.recommend_list.length > 0
        }
    },
    mounted () {
        const options = this.$route.query
        this.no_reach_bottom = true
        this.name = options.name || ''
        this.type = options.type || ''
        this.feature = options.feature || ''
        this.getHistory()
        this.$nextTick(() => {
            this.$refs.search_input.focus()
        })
        if (this.name) {
            this.getData()
        }
    },
    destroyed() {
        TIMER && clearTimeout(TIMER)
    },
    methods: {
        foldHistory() {
            this.fold_history_list = !this.fold_history_list
        },
        goDetail(item, type) {
            const name  = item.searchArray.join('')
            const { href } = item
            const url = `${href}&status=${BUILDING_STATUS[type] || ''}`
            this.$router.push({
                path: url
            })
            this.addHisotry(name)
        },
        checkNameChange: debounce(function(){
            if (this.name === '') {
                this.search_items=[]
                return
            }
            this.show_search_loading = true
            this.getSearchData()
        }, 200),
        changeType (type) {
            this.type = type
            this.getData()
        },
        resetName () {
            this.submit_state = SUBMIT_TYPE.NONE
            this.name = ''
            this.items = []
            this.search_items = []
            this.recommend_list = []
            this.no_reach_bottom = true
        },
        selectHot (e) {
            const { href, id, position, index } = e.currentTarget.dataset
            Service.interestingEvent({
                pos_name: position,
                interesting_id: id,
                event: 'click',
                pos: index
            })
            this.$router.push({
                path: href
            })
        },
        getHistory () {
            const { type } = this.$route.query
            if (type) {
                this.history = LocalData.filter_search.get(type)
            } else {
                this.history = LocalData.search.get()
            }
        },
        addHisotry (name) {
            const { type } = this.$route.query
            if (type) {
                this.history = LocalData.filter_search.add(type, name)
            } else {
                this.history = LocalData.search.add(name)
            }
        },
        removeHisotry () {
            const { type } = this.$route.query
            if (type) {
                LocalData.filter_search.remove(type)
            } else {
                LocalData.search.remove()
            }
            this.history = []
        },
        selectHistory ({ currentTarget }) {
            const { name } = currentTarget.dataset
            this.goSearch(name, true)
        },
        async getSearchData() {
            let { type } = this
            let data
            this.no_reach_bottom = true
            this.searchBrand()
            if (type === '在售楼盘') {
                data = await this.getSuplusBuilding()
            } else if (type === '热门公寓') {
                data = await this.getBusinessBuilding(false)
            } else {
                const options = {
                    per: 10,
                    page: 1,
                    name: this.name,
                    status: this.getStatus()
                }
                data = await Service.getBuildings(options, false)
                this.handleItems(data)
            }
            this.show_search_loading = false
        },
        getStatus() {
            let { type } = this
            if (type === '最新取证') {
                type = '最新开盘'
            }
            if (type === '即将预售') {
                type = '即将取证'
            }
            return type === '全部' || type === '全部楼盘' || !type ? '' : type
        },
        getData () {
            this.start = true
            this.loading = true
            this.no_reach_bottom = false
            if (this.feature) {
                this.getDataByFeature()
                return
            }
            const { type } = this
            if (type === '在售楼盘') {
                this.getSuplusBuilding()
            } else if (type === '热门公寓') {
                this.getBusinessBuilding()
            } else {
                const options = {
                    per: this.per,
                    page: this.page,
                    name: this.name,
                    status: this.getStatus()
                }
                Service.getBuildings(options).then(data => {
                    try {
                        const ids = data.items.reduce((prev, item) => {
                            if (prev.indexOf(item.building_id) === -1) {
                                prev.push(item.building_id)
                            }
                            return prev
                        }, [])
                        UserLog.searchHouse(this.name, ids)
                    } catch (e) {
                        console.error(e)
                    }
                    this.handleItems(data)
                })
            }
        },
        async searchBrand () {
            const items = await Service.getBrand(this.name)
            this.brand = items && items.length ? items[0] : {}
            console.error(items)
        },
        async getRecommend () {
            const { type, per } = this
            const params = {
                per,
                page: 1
            }
            let data
            if (type === '在售楼盘') {
                data = await SurplusBuildingService.getSurplusBuildings(params)
                data.items.forEach(handleSurplusItem)
            } else if (type === '热门公寓') {
                data = await BusinessBuildingService.list(params, false)
            } else {
                const options = {
                    ...params,
                    status: this.getStatus()
                }
                data = await Service.getBuildings(options)
            }
            this.recommend_list = data.items
        },
        getDataByFeature () {
            Service.getBuildings({
                page: this.page,
                name: this.name,
                feature: this.feature
            }).then((data) => {
                this.handleItems(data)
            })
        },
        handleItems (data) {
            if (this.submit_state !== SUBMIT_TYPE.NONE) {
                this.handleData(data)
                this.submit_state = SUBMIT_TYPE.DONE
            } else {
                this.handleSearchItem(data)
            }
            return data
        },
        handleSearchItem(data) {
            this.search_items = data.items.map((element) => {
                return {
                    searchArray: element.name.split(''),
                    searchHouseName: element.fulltext_house_name && element.fulltext_house_name.split(''),
                    href: element.href,
                    zone: element.zone,
                    zone_section: element.zone_section,
                    status: element.status,
                    price_desc_arr: element.price_desc_arr,
                    customized_price: element.customized_price
                }
            })
        },
        getSuplusBuilding () {
            return SurplusBuildingService.getSurplusBuildings({
                per: this.per,
                page: this.page,
                name: this.name
            }).then((data) => {
                data.items.forEach(handleSurplusItem)
                return data
            }).then(this.handleItems)
        },
        getBusinessBuilding (loading=true) {
            return BusinessBuildingService.list({
                per: this.per,
                page: this.page,
                name: this.name
            }, loading).then(this.handleItems)
        },
        goSearch (name, isSelect = false) {
            this.submit_state = SUBMIT_TYPE.DOING
            this.per = 10;
            this.name = name || this.hot_search_keyword
            if (!isSelect) {
                this.addHisotry(this.name)
            }
            if (this.name && this.name === this.hot_search_keyword) {
                Service.interestingEvent({
                    interesting_id: this.hot_search_keyword_id,
                    event: 'click',
                    pos_name: 'hot_search_keyword',
                    pos: 0
                })
            }
            this.page = 1
            this.getData()
        },
        search ({ target }) {
            this.goSearch(target.value)
        },
        submit ({ target }) {
            this.goSearch(target.name.value)
        },
        startSearch () {
            this.focus = true
            this.no_reach_bottom = true
            this.start = false
            this.loading = false
        },
        scrollList () {
            this.focus = false
            console.log('12312')
        },
        searchBlur () {
            this.focus = false
        },
        onCancel () {
            const pages = getCurrentPages()
            if (pages.length > 1) {
                this.$router.back()
            } else {
                this.$router.replace({
                    name: 'index'
                })
            }
        }
    },
    components: {
        HouseItem,
        SurplusHouseItem,
        SearchItem,
        SearchSelect,
        SearchLoading
    }
}
